<!--
 * @Author: 请在根目录下.vscode改成你的名字
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-09-09 15:15:47
 * @LastEditTime: 2019-09-29 12:43:53
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 -->
<template>
  <div class="hotlist">
    <div class="hotlist-header">热点企业</div>
    <div v-if="hotlistData.length>1" class="hotlist-con">
      <div v-for="(hotlist,hotlistIndex) in hotlistData" :key="hotlistIndex" class="hotlist-item">
        <div class="item-icon">
          <div class="item-icon-box">
            <img v-if="hotlistIndex==0" src="../../../assets/img/hotImg1.png" alt="">
            <img v-if="hotlistIndex==1" src="../../../assets/img/hotImg2.png" alt="">
            <img v-if="hotlistIndex==2" src="../../../assets/img/hotImg3.png" alt="">
            <span v-if="hotlistIndex>2" class="item-icon-num">{{ hotlistIndex+1 }}</span>
          </div>
          <div class="item-icon-img">
            <el-image class="item-icon-log" :src="hotlist.companyLogo |getImg" lazy />
            <!-- <img class="item-icon-log" :src="hotlist.companyLogo | getImg" alt=""> -->
          </div>
        </div>
        <div
          class="item-txt"
          :class="[{'item-txt-color':hotlistIndex>2}]"
        >{{ hotlist.companyName }}</div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/home/home.js' // 请求接口

export default {
  data() {
    return {
      //  企业热榜
      hotlistData: []
    }
  },
  created() {
    // 企业热榜
    get.enterpriseHot().then(res => {
      this.hotlistData = res.result
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>

<style scoped lang='scss'>
  /*企业热榜*/
  .hotlist{
    width: 300px;
    height: auto;
    .hotlist-header{
      position: relative;
      width: 100%;
      height: 40px;
      font-size: 40px;
      color: #060606;
      text-indent: 20px;
      margin-bottom: 15px;
      &:before{
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        left: 0;
        top: 12px;
        border-bottom: 8px solid transparent;
        border-top: 8px solid transparent;
        border-left: 8px solid #BE2316;
      }
    }
    .hotlist-con{
      width: 100%;
      height: auto;
      .hotlist-item{
        width: 100%;
        height: 68px;
        cursor: pointer;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        margin-bottom: 15px;
        background: url("../../../assets/img/hotBg4.png") no-repeat;
        background-size: 100% 100%;
        &:nth-child(1){
          background: url("../../../assets/img/hotBg1.png") no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(2){
          background: url("../../../assets/img/hotBg2.png") no-repeat;
          background-size: 100% 100%;
        }
        &:nth-child(3){
          background: url("../../../assets/img/hotBg3.png") no-repeat;
          background-size: 100% 100%;
        }
        .item-icon{
          float: left;
          .item-icon-box{
            float: left;
            width: 27px;
            height: 27px;
            margin: 20px 10px 0 20px;
            line-height: 27px;
            text-align: center;
          }
          .item-icon-img{
            float: left;
            width: 27px;
            height: 27px;
            margin-top: 19px;
            overflow: hidden;
            border-radius: 50%;
            .item-icon-log{
              width: 100%;
              height: 100%;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .item-txt{
          width: 200px;
          float: left;
          line-height: 67px;
          color: #fff;
          font-size: 14px;
          text-indent: 10px;
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &.item-txt-color{
            color: #333;
          }
        }

      }
    }
  }
</style>
